import styled from 'styled-components';
import C from '@assets/themes/colors';

interface IRootProps {
  flex?: Boolean;
  top?: string;
  float?: Boolean;
}

export const Root = styled.div`
  height: ${(props: IRootProps) => props.top && 'calc(100% - '+props.top+')'};
  width: 100%;
  overflow-x: hidden;
  overflow-y: scroll;
  position: relative;
  border-radius: 5px;
  box-shadow: 4px 4px 20px 2px rgba(0, 0, 0, 0.05);
  background-color: #ffffff;
  .group-list {
    display: ${(props: IRootProps) => props.flex ? 'grid' : 'unset'};
    grid-template-columns: ${(props: IRootProps) => props.flex ? 'repeat(auto-fill, 230px)' : 'unset'};
    justify-content: ${(props: IRootProps) => props.flex ? 'space-between' : 'unset'};
  }
  .infinite-scroll-component__outerdiv{
    height: 100%;
  }
`;

export const Container = styled.div`
  position: relative;  

`
export const ListContainer = styled.div`
  width: 100%;
  position: relative;
  height: calc(100vh - 325px);
  overflow-y: auto;
  overflow-x: hidden;  
 
`


export const TypeContainer = styled.div`
  
`

export const OrderByLabel = styled.div`
  width: 100%;
  font-size: 16px;
  font-weight: 500;
  text-align: end;
  padding: 18px 14px 0px;
  box-sizing: border-box;
`

export const ListEmty = styled.div`
  padding: 5%  15%;
  text-align: center;  
`

export const Text = styled.div`
  height: 45px;
  width:100%;
  padding: 20px 0px;
  text-align:center;
  font-size: 20px;
  font-weight: normal;
  color: #122442;
  display: inline-block;
`;

export const Tittle = styled.label`
  font-family: Roboto;
  font-size: 30px;
  font-weight: 500;
  text-align: left;
  color: #204078;
  display:block;
`;

export const SubTittle = styled.label`
  margin: 29px 0 8%;
  font-family: Roboto;
  font-size: 18px;
  font-weight: normal;
  text-align: left;
  color: #122442;
  display:block;
`;

export const Result = styled.div`
  margin: 40px 25px 25px 39px;
  font-size: 25px;
  font-weight: normal;
  color: ${C.DARK_BLUE};
`;
export const Counter = styled.span`
    font-size: 15px;
    font-weight: normal;
    color: #8891a0;
    margin-left: 24px;
`;

export const Orderby = styled.span`
  font-size: 15px;
  font-weight: normal;
  color: #8891a0;
  float:  ${(props: IRootProps) => props.float && 'right'};
  display:  ${(props: IRootProps) => !props.float && 'block'};
  position: ${(props: IRootProps) => !props.float && 'absolute'};
  right: ${(props: IRootProps) => !props.float && '0'};
  padding: ${(props: IRootProps) => !props.float && '6px 10px'};
`;



export const TabNoDesignsContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  margin: 13px 13px 0px 13px;
  padding-top:100px;
`

export const EmptyIcon = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 220px;
  max-width: 220px;
  max-height: 240px;
  overflow: hidden;
  margin: 0px 50px 0px 0px;
`
export const EmptyIconScale = styled.div`
  transform: scale(0.55);
`

export const EmptyTextContainer = styled.div`
`

export const EmptyTitle = styled.div`
  max-width: 455px;
  padding: 30px 0px 30px 0px;
  font-family: Roboto;
  font-size: 30px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: ${C.BLUE};
`

export const EmptySubtitle = styled.div`
  max-width: 417px;
  font-family: Roboto;
  font-size: 18px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: ${C.DARK_BLUE};
`

export const TabEmptySubtitle = styled.div`
  max-width: 417px;
  font-family: Roboto;
  font-size: 18px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: ${C.DARK_BLUE};
`

export const EmptyButton = styled.div`
  margin: 26px 0px 0px 0px;
`
